// actions.js
import apiClient from "../../../../../services/apiClient";
import { districts } from './personalConstants';

  export const staffStatisticsActions = {
    // Отримати звіт по штатному розкладу для садочка або районів
    getStaffReport: async (params = {}) => {
      const { 
        kindergarten_id, 
        district, 
        districts, 
        position_types, 
        status, 
        genders,
        position_search,
        report_date 
      } = params;
      
      let queryParams = [];
      
      if (kindergarten_id) {
        queryParams.push('kindergarten_id=' + kindergarten_id);
      }
      
      if (districts) {
        queryParams.push('districts=' + districts);
      } else if (district) {
        queryParams.push('district=' + district);
      }
      
      // Добавляем новые параметры
      if (position_types) {
        queryParams.push('position_types=' + position_types);
      }
      
      if (status) {
        queryParams.push('status=' + status);
      }
      
      if (genders) {
        queryParams.push('genders=' + genders);
      }
      
      if (position_search) {
        queryParams.push('position_search=' + encodeURIComponent(position_search));
      }
      
      if (report_date) {
        queryParams.push('report_date=' + report_date);
      }
      
      const linkGet = 'staff-report?' + queryParams.join('&');
      
      return await apiClient.get(linkGet);
  },

  // Отримати детальний звіт по конкретній посаді
  getPositionDetailReport: async (params = {}) => {
    const { kindergarten_id, position_id, district, districts, report_date } = params;
    
    let queryParams = [];
    
    if (kindergarten_id) {
      queryParams.push('kindergarten_id=' + kindergarten_id);
    }
    
    if (position_id) {
      queryParams.push('position_id=' + position_id);
    }
    
    // Поддержка как одного района, так и нескольких
    if (districts) {
      queryParams.push('districts=' + districts);
    } else if (district) {
      queryParams.push('district=' + district);
    }
    
    if (report_date) {
      queryParams.push('report_date=' + report_date);
    }
    
    const linkGet = 'staff-report/position-details?' + queryParams.join('&');
    
    return await apiClient.get(linkGet);
  },

  // Отримати список доступних районів (тепер з констант)
  getDistricts: async () => {
    // Повертаємо статичний список районів з констант
    return Promise.resolve({
      data: {
        success: true,
        data: districts
      }
    });
  },

  // Отримати список садочків для районів
  getKindergartensByDistrict: async (districts) => {
    let queryParams = [];
    
    if (districts) {
      queryParams.push('districts=' + districts);
    }
    
    const linkGet = 'kindergartens?' + queryParams.join('&');
    
    return await apiClient.get(linkGet);
  }
};